module.exports = __webpack_public_path__ + "img/icon-menu-right.663d493b.svg";